import { ActiveInactive, CreateAddress } from '@tecex-api/data';
import { AddressCardAddressVM } from '../../../interfaces/address/address.vm';

export const mapAddressCreatePayload = (address: AddressCardAddressVM): CreateAddress => ({
  DefaultAddress: address.isDefault,
  CompanyName: address.companyName,
  City: address.city,
  All_Countries: address.country,
  Name: address.tag,
  Contact_Email: address.email,
  Contact_Full_Name: address.contactPerson,
  Province: address.state,
  Address1: address.streetAddress,
  Address2: address.streetAddressTwo,
  Address3: address.streetAddressThree,
  Postal_Code: address.zip,
  Contact_Phone_Number: address.phone,
  AdditionalNumber: address.additionalPhone,
  AddressStatus: address.isActive ? ActiveInactive.ACTIVE : ActiveInactive.INACTIVE,
  PickupPreference: address.pickupPreference,
});
